import {IMAGES_URL} from "modules";

export const getSquadImage = (squad?: {abbr: string}) => {
	if (!squad) {
		return "";
	}

	return `${IMAGES_URL}flags/${squad.abbr}.svg`;
};
